<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" color="primary" text) {{translations.button}}
    v-card.pb-5
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }} {{ info.name }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid)
          v-row.px-0.px-md-10.pb-0.pb-sm-2.pb-md-4
            v-col(cols="12")
              BaseDefinitionList(:items="gameDetails" keysAlign="text-left text-sm-right")

</template>

<script>

  import OperatorIpList from "@/components/lists/OperatorIpList";

  export default {
    name: "GameInfoDialog",
    components: {
      OperatorIpList,
    },
    props: {
      info:{
        type: Object,
        default: function(){
          return {}
        }
      },
      buttonText: {
        type: String,
        default: 'See competition'
      },
    },
    data:() => ({
      dialog: false,
    }),
    computed: {
      translations() {
        return this.$t("components.gamesInfoDialog");
      },
      gameDetails(){
        return [
          {
            key: this.translations.name,
            value: this.info.name
          },
          {
            key: this.translations.alias,
            value: this.info.alias
          },
          {
            key: this.translations.type,
            value: this.info.type
          },
          {
            key: this.translations.key,
            value: this.info.key
          },
          {
            key: this.translations.jurisdictions,
            value: this.info.jurisdictions.map(item=>{ return item.text }),
            type: 'chip'
          },
          {
            key: this.translations.providers,
            value: this.info.provider.n
          },
        ];
      },
    },
  }
</script>

<style lang="sass">
</style>